import {
  getMillionairesConnectProgressFs,
  saveMillionairesConnectProgressFs
} from './firestoreStore';

const progressKey = (userId) => `shem_mc_progress_${userId || 'anonymous'}`;

const readLocalProgress = (userId) => {
  if (typeof window === 'undefined') return [];
  try {
    const parsed = JSON.parse(window.localStorage.getItem(progressKey(userId)) || '[]');
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    return [];
  }
};

const writeLocalProgress = (userId, completedLessonIds) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(progressKey(userId), JSON.stringify(completedLessonIds));
  } catch (error) {
    // Continue with cloud persistence when browser storage is unavailable.
  }
};

export const loadMillionairesConnectProgress = async (userId) => {
  const localIds = readLocalProgress(userId);
  if (!userId || process.env.REACT_APP_USE_FIREBASE !== 'true') return localIds;

  try {
    const remoteProgress = await getMillionairesConnectProgressFs(userId);
    const remoteIds = Array.isArray(remoteProgress?.completedLessonIds)
      ? remoteProgress.completedLessonIds
      : [];
    const mergedIds = [...new Set([...localIds, ...remoteIds])];
    writeLocalProgress(userId, mergedIds);
    return mergedIds;
  } catch (error) {
    console.error('Failed to load Millionaires Connect progress', error);
    return localIds;
  }
};

export const persistMillionairesConnectProgress = async (userId, completedLessonIds) => {
  const uniqueIds = [...new Set(completedLessonIds.filter(Boolean))];
  writeLocalProgress(userId, uniqueIds);
  if (!userId || process.env.REACT_APP_USE_FIREBASE !== 'true') return uniqueIds;

  try {
    await saveMillionairesConnectProgressFs(userId, uniqueIds);
  } catch (error) {
    // Local progress remains available if the network is temporarily offline.
    console.error('Failed to sync Millionaires Connect progress', error);
  }
  return uniqueIds;
};
